import { Config } from "../utils";
import ApiController from "./api";
import { Endpoints } from "./types";

export const endpoints: Endpoints = {
  getProductData: {
    method: "GET",
    url: "/product",
  },
  addProductToCart: {
    method: "POST",
    url: "/cart/add",
    data: {
      quantity: 1,
    },
  },
};

export class WooptimaAPI extends ApiController {
  getProduct = async (productID: string | number) =>
    this.request({
      endpoint: endpoints.getProductData,
      args: {
        params: Config.REACT_APP_ENV === 'staging' ? {
          include: ['theme', 'config', 'translations'].join(',')
        } : {
          include: ['config'].join(',')
        },
      },
      query: productID
    });
  addProductToCart = async (productID: number, data: any) =>
    this.request({
      endpoint: endpoints.addProductToCart,
      query: productID,
      args: {
        data: {
          quantity: 1,
          ...data
        },
      },
    });
}
